import { getDeepLinkBaseUrl } from './productHosts';

/**
 * Canonical native-app deep link: `<app-host>/open?<params>`.
 *
 * `/open` is the only path registered for Universal Links (iOS AASA) and
 * Android App Links (manifest pathPrefix) since the unified migration
 * (lureo-unity-4 74b2407d) — path-based `/projects/…` or `/editor/…` URLs
 * never reach the app. The query keys below are exactly what Unity's
 * DeepLinkService parses; anything else is ignored.
 *
 * Null when the deep-link host is not configured for this origin (share links
 * 3.7): callers show an error state instead of a link into the wrong environment.
 */
export interface AppDeepLinkParams {
  projectInstanceId?: string;
  sceneInstanceId?: string;
  /** Capability token for draft/private scenes; resolved server-side by the app. */
  scenePinCode?: string;
  /** Routes the app to the creator storyview (drafts + publish controls) instead of the consumer project page. */
  isCreator?: boolean;
}

export function buildAppDeepLink(params: AppDeepLinkParams): string | null {
  const baseUrl = getDeepLinkBaseUrl();
  if (!baseUrl) return null;
  const query = new URLSearchParams();
  if (params.projectInstanceId) query.set('project-instance-id', params.projectInstanceId);
  if (params.sceneInstanceId) query.set('scene-instance-id', params.sceneInstanceId);
  if (params.scenePinCode) query.set('scene-pin-code', params.scenePinCode);
  if (params.isCreator) query.set('is-creator', 'true');
  return `${baseUrl}/open?${query.toString()}`;
}
